require.register("common/controllers/navCtrl", function(exports, require, module){
  $0
  
});

